/**
 * Labstep
 *
 * @module components/DeviceTemplate/Table
 * @desc Table to display device templates
 */

import {
  Action,
  DeviceActionMenu,
} from 'labstep-web/components/Device/Action/Menu';
import { EntityLink } from 'labstep-web/components/Entity/Link';
import { EntityTableParamsContainer as EntityTable } from 'labstep-web/components/Entity/Table';
import type { Device } from 'labstep-web/models/device.model';
import type React from 'react';
import type { DeviceTemplateTableProps } from './types';

export const DeviceTemplateTable: React.FC<
  DeviceTemplateTableProps
> = ({ deviceTemplates, ...rest }) => {
  return (
    <EntityTable
      id="device-category-table"
      entities={deviceTemplates}
      primaryColumn={{
        header: 'Name',
        content: (device: Device) => <EntityLink entity={device} />,
        cellProps: { style: { flex: 3 } },
      }}
      actionMenu={({ entity }) => (
        <DeviceActionMenu
          device={entity}
          actions={[
            Action.share,
            Action.duplicate,
            Action.transfer_ownership,
            Action.delete,
          ]}
        />
      )}
      {...rest}
    />
  );
};

export default DeviceTemplateTable;
